import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  CreditCard,
  TrendingUp,
  GraduationCap,
  ArrowUpRight,
  Home,
} from "lucide-react";
import { useI18n } from "@/i18n/i18n";

const ICONS = [CreditCard, TrendingUp, GraduationCap, Home];
const SPANS = [
  "lg:col-span-2 lg:row-span-2",
  "lg:col-span-1",
  "lg:col-span-2",
  "lg:col-span-2",
];
const MEDIA = [
  // Reparación de Crédito - tarjeta y reporte
  "https://images.pexels.com/photos/4968391/pexels-photo-4968391.jpeg?auto=compress&cs=tinysrgb&w=1400",
  // Asesoría Financiera - asesor con cliente
  "https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&w=900",
  // Educación Financiera - laptop y notas
  "https://images.pexels.com/photos/4386431/pexels-photo-4386431.jpeg?auto=compress&cs=tinysrgb&w=1200",
  // Preparación para Hipoteca - llaves y casa
  "https://images.pexels.com/photos/1396122/pexels-photo-1396122.jpeg?auto=compress&cs=tinysrgb&w=1200",
];

export default function ServicesBento() {
  const { tr } = useI18n();
  return (
    <section className="py-24 lg:py-32 relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-14">
          <p className="overline text-[color:var(--mc-gold)]">{tr.services.overline}</p>
          <h2 className="font-serif-display text-4xl sm:text-5xl font-semibold tracking-tight mt-4 leading-tight text-white">
            {tr.services.title_pre}{" "}
            <em className="not-italic italic bg-gradient-to-r from-[color:var(--mc-cyan-2)] to-[color:var(--mc-cyan)] bg-clip-text text-transparent">
              {tr.services.title_em}
            </em>
          </h2>
          <p className="mt-5 text-white/70 text-lg leading-relaxed">{tr.services.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 auto-rows-[220px]">
          {tr.services.cards.map((s, i) => {
            const Icon = ICONS[i] || CreditCard;
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                className={`mc-card p-8 flex flex-col justify-between overflow-hidden relative group ${SPANS[i] || "lg:col-span-1"}`}
                data-testid={`service-card-${i}`}
              >
                {MEDIA[i] && (
                  <>
                    <img
                      src={MEDIA[i]}
                      alt=""
                      loading="lazy"
                      decoding="async"
                      className="absolute inset-0 w-full h-full object-cover opacity-30 group-hover:opacity-40 group-hover:scale-105 transition-all duration-500 pointer-events-none"
                    />
                    <div
                      className="absolute inset-0 pointer-events-none"
                      style={{
                        background:
                          "linear-gradient(180deg, rgba(10,19,64,0.55) 0%, rgba(5,11,36,0.92) 100%)",
                      }}
                    />
                  </>
                )}
                <div className="flex items-start justify-between relative">
                  <div className="h-12 w-12 rounded-2xl bg-[color:var(--mc-bg-2)]/80 backdrop-blur border border-[color:var(--mc-cyan)]/40 text-[color:var(--mc-cyan)] flex items-center justify-center">
                    <Icon className="h-6 w-6" />
                  </div>
                  <ArrowUpRight className="h-5 w-5 text-white/60" />
                </div>
                <div className="relative">
                  <h3 className="font-heading text-2xl font-semibold tracking-tight mt-6 text-white drop-shadow">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-white/80 leading-relaxed text-sm">{s.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>

        <div className="mt-12 flex justify-center">
          <Link to="/servicios" className="btn-ghost" data-testid="services-see-all">
            {tr.services.see_all} <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
